var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagsShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 96C128 42.98 170.1 0 224 0C277 0 320 42.98 320 96V160H384C419.3 160 448 188.7 448 224H416C416 206.3 401.7 192 384 192H64C46.33 192 32 206.3 32 224V416C32 433.7 46.33 448 64 448H160V480H64C28.65 480 0 451.3 0 416V224C0 188.7 28.65 160 64 160H128V96zM160 160H288V96C288 60.65 259.3 32 224 32C188.7 32 160 60.65 160 96V160zM320 352C320 387.3 348.7 416 384 416C419.3 416 448 387.3 448 352V336C448 327.2 455.2 320 464 320C472.8 320 480 327.2 480 336V352C480 405 437 448 384 448C330.1 448 288 405 288 352V336C288 327.2 295.2 320 304 320C312.8 320 320 327.2 320 336V352zM192 320C192 284.7 220.7 256 256 256H512C547.3 256 576 284.7 576 320V448C576 483.3 547.3 512 512 512H256C220.7 512 192 483.3 192 448V320zM256 288C238.3 288 224 302.3 224 320V448C224 465.7 238.3 480 256 480H512C529.7 480 544 465.7 544 448V320C544 302.3 529.7 288 512 288H256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagsShopping);
export default __webpack_public_path__ + "static/media/bags-shopping.206415223ee103680cb31612ca1106c8.svg";
export { ForwardRef as ReactComponent };